import { motion } from "framer-motion";
import { Clock, HeartHandshake, Leaf as LeafIcon } from "lucide-react";
import { IMAGES } from "../data/menu";
import { Leaf } from "./Decor";

const FEATURES = [
  { icon: HeartHandshake, title: "Cooked Like Home", text: "Traditional family recipes, prepared fresh on every order." },
  { icon: LeafIcon, title: "Pure & Hygienic", text: "Quality ingredients and a clean cloud-kitchen you can trust." },
  { icon: Clock, title: "Open Every Day", text: "Serving breakfast, lunch and dinner, 9:00 AM to 6:00 PM." },
];

export const BrandIntro = () => (
  <section className="relative bg-[#FAF4EC] py-16 sm:py-24 overflow-hidden" data-testid="brand-intro">
    <Leaf className="absolute left-2 top-6 w-12 h-12 opacity-70" />
    <Leaf flip className="absolute right-2 bottom-6 w-12 h-12 opacity-70" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative order-2 lg:order-1"
      >
        <div className="overflow-hidden rounded-[2rem] shadow-[0_24px_50px_-18px_rgba(61,35,20,0.3)] aspect-[4/3] group">
          <img
            src={IMAGES.thali}
            alt="Traditional Indian thali at Harshi's Kitchen"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="absolute -top-5 -right-4 bg-[#D86A7A] text-white rounded-2xl px-5 py-3 shadow-lg rotate-3">
          <p className="font-hand text-xl leading-none">Since 2025</p>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="order-1 lg:order-2"
      >
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#3A6B4C] mb-4">Our Story</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#3D2314] leading-snug">
          A small cloud kitchen with a <span className="italic text-[#D86A7A]">big heart</span>
        </h2>
        <p className="mt-5 text-[#5A4232] leading-relaxed text-base sm:text-lg">
          Harshi&rsquo;s Kitchen began in 2025 with one simple promise — food that tastes like it was made in your
          own home. Every paratha, sabzi and snack is cooked fresh on order, packed with care, and sent to you with
          the warmth of a family kitchen.
        </p>
        <div className="mt-8 space-y-5">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="flex items-start gap-4"
            >
              <span className="shrink-0 w-11 h-11 rounded-xl bg-white border border-[#EFE6DC] flex items-center justify-center text-[#D86A7A]">
                <f.icon size={20} />
              </span>
              <div>
                <h3 className="font-semibold text-[#3D2314]">{f.title}</h3>
                <p className="text-sm text-[#8A7364] mt-0.5">{f.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
